export const checkVarEnvironment = (environment: string | undefined) => {
    if (['true', 'false'].includes(environment || '')) {
        return environment === 'true';
    }
    return false;
};

const isUnset = (val: string | undefined, placeholder: string) =>
    val === undefined || val === '' || val === placeholder;

const getEnvVar = (key: string): string | undefined => {
    const openshiftKey = key.replace('VITE_WEBVIEW_', 'WEBVIEWS_WEBVIEW_');
    const globalVar = (window as any)[openshiftKey];
    const placeholder = '${' + openshiftKey + '}';

    if (!isUnset(globalVar, placeholder)) return globalVar;

    const viteValue = (import.meta.env as any)[key] as string | undefined;
    return viteValue;
};

export enum ViteEnvironment {
    VITE_WEBVIEW_POSTSALES_ENABLED = 'VITE_WEBVIEW_POSTSALES_ENABLED',
    VITE_WEBVIEW_DEVICES_ENABLED = 'VITE_WEBVIEW_DEVICES_ENABLED',
    VITE_WEBVIEW_O2TELEVISION_EXPLORE_ENABLED = 'VITE_WEBVIEW_O2TELEVISION_EXPLORE_ENABLED',
    VITE_WEBVIEW_O2CLOUD_EXPLORE_ENABLED = 'VITE_WEBVIEW_O2CLOUD_EXPLORE_ENABLED',
    VITE_WEBVIEW_PROFILE_OBD_ENABLED = 'VITE_WEBVIEW_PROFILE_OBD_ENABLED',
    VITE_WEBVIEW_BLUETV_CONVERGENT_ENABLED = 'VITE_WEBVIEW_BLUETV_CONVERGENT_ENABLED',
    VITE_WEBVIEW_BLUEADDLINE_CONVERGENT_ENABLED = 'VITE_WEBVIEW_BLUEADDLINE_CONVERGENT_ENABLED',
    VITE_WEBVIEW_TV_CONVERGENT_ENABLED = 'VITE_WEBVIEW_TV_CONVERGENT_ENABLED',
    VITE_WEBVIEW_DEVICES_CONVERGENT_ENABLED = 'VITE_WEBVIEW_DEVICES_CONVERGENT_ENABLED',
    VITE_WEBVIEW_O2CLOUD_CONVERGENT_ENABLED = 'VITE_WEBVIEW_O2CLOUD_CONVERGENT_ENABLED',
    VITE_WEBVIEW_RATES_CONVERGENT_ENABLED = 'VITE_WEBVIEW_RATES_CONVERGENT_ENABLED',
    VITE_WEBVIEW_ADDLINE_CONVERGENT_ENABLED = 'VITE_WEBVIEW_ADDLINE_CONVERGENT_ENABLED',
    VITE_WEBVIEW_BLUETV_MOBILE_ENABLED = 'VITE_WEBVIEW_BLUETV_MOBILE_ENABLED',
    VITE_WEBVIEW_BLUEGOCONVERGENT_MOBILE_ENABLED = 'VITE_WEBVIEW_BLUEGOCONVERGENT_MOBILE_ENABLED',
    VITE_WEBVIEW_TV_MOBILE_ENABLED = 'VITE_WEBVIEW_TV_MOBILE_ENABLED',
    VITE_WEBVIEW_DEVICES_MOBILE_ENABLED = 'VITE_WEBVIEW_DEVICES_MOBILE_ENABLED',
    VITE_WEBVIEW_O2CLOUD_MOBILE_ENABLED = 'VITE_WEBVIEW_O2CLOUD_MOBILE_ENABLED',
    VITE_WEBVIEW_RATES_MOBILE_ENABLED = 'VITE_WEBVIEW_RATES_MOBILE_ENABLED',
    VITE_WEBVIEW_ADDLINE_MOBILE_ENABLED = 'VITE_WEBVIEW_ADDLINE_MOBILE_ENABLED',
    VITE_WEBVIEW_BLUETV_FIBER_ENABLED = 'VITE_WEBVIEW_BLUETV_FIBER_ENABLED',
    VITE_WEBVIEW_BLUEGOCONVERGENT_FIBER_ENABLED = 'VITE_WEBVIEW_BLUEGOCONVERGENT_FIBER_ENABLED',
    VITE_WEBVIEW_TV_FIBER_ENABLED = 'VITE_WEBVIEW_TV_FIBER_ENABLED',
    VITE_WEBVIEW_DEVICES_FIBER_ENABLED = 'VITE_WEBVIEW_DEVICES_FIBER_ENABLED',
    VITE_WEBVIEW_O2CLOUD_FIBER_ENABLED = 'VITE_WEBVIEW_O2CLOUD_FIBER_ENABLED',
    VITE_WEBVIEW_RATES_FIBER_ENABLED = 'VITE_WEBVIEW_RATES_FIBER_ENABLED',
    VITE_WEBVIEW_ADDLINE_FIBER_ENABLED = 'VITE_WEBVIEW_ADDLINE_FIBER_ENABLED',
    VITE_STOPPER_LOGIN_DISABLED = 'VITE_STOPPER_LOGIN_DISABLED',
    VITE_STOPPER_LOGIN_MC_DISABLED = 'VITE_STOPPER_LOGIN_MC_DISABLED',
    VITE_STOPPER_HOME_DISABLED = 'VITE_STOPPER_HOME_DISABLED',
    VITE_STOPPER_CONSUMPTIONS_DISABLED = 'VITE_STOPPER_CONSUMPTIONS_DISABLED',
    VITE_STOPPER_BILLS_DISABLED = 'VITE_STOPPER_BILLS_DISABLED',
    VITE_STOPPER_BILL_PAYMENT_DISABLED = 'VITE_STOPPER_BILL_PAYMENT_DISABLED',
    VITE_STOPPER_PROFILE_ORDERS_DISABLED = 'VITE_STOPPER_PROFILE_ORDERS_DISABLED',
    VITE_STOPPER_PROFILE_CUSTOMER_DATA_DISABLED = 'VITE_STOPPER_PROFILE_CUSTOMER_DATA_DISABLED',
    VITE_STOPPER_PROFILE_NOTIFICATIONS_DISABLED = 'VITE_STOPPER_PROFILE_NOTIFICATIONS_DISABLED',
    VITE_STOPPER_PROBLEMS_DISABLED = 'VITE_STOPPER_PROBLEMS_DISABLED',
    VITE_WEBVIEW_O2CLOUD_HOME_ENABLED = 'VITE_WEBVIEW_O2CLOUD_HOME_ENABLED',
    VITE_WEBVIEW_CARDS_PRECLIENT_ENABLED = 'VITE_WEBVIEW_CARDS_PRECLIENT_ENABLED',
    VITE_WEBVIEW_BLUEDEVICES_CONVERGENT_ENABLED = 'VITE_WEBVIEW_BLUEDEVICES_CONVERGENT_ENABLED',
    VITE_WEBVIEW_BLUEDEVICES_MOBILE_ENABLED = 'VITE_WEBVIEW_BLUEDEVICES_MOBILE_ENABLED',
    VITE_WEBVIEW_BLUEDEVICES_FIBER_ENABLED = 'VITE_WEBVIEW_BLUEDEVICES_FIBER_ENABLED',
    VITE_WEBVIEW_DUPLICATE_ESIM_ENABLED = 'VITE_WEBVIEW_DUPLICATE_ESIM_ENABLED',
    VITE_WEBVIEW_MULTISIM_ENABLED = 'VITE_WEBVIEW_MULTISIM_ENABLED',
    VITE_WEBVIEW_OWNERSHIP_CHANGE_ENABLED = 'VITE_WEBVIEW_OWNERSHIP_CHANGE_ENABLED',
    VITE_WEBVIEW_PARADIGMA_ENTERTAINMENT = 'VITE_WEBVIEW_PARADIGMA_ENTERTAINMENT',
    VITE_WEBVIEW_PARADIGMA_POSTSALES = 'VITE_WEBVIEW_PARADIGMA_POSTSALES',
}

type IEnvironment = {
    [key in ViteEnvironment]: boolean;
};

export const managementEnvironment = (): IEnvironment => {
    const result = {} as IEnvironment;

    Object.values(ViteEnvironment).forEach((envKey) => {
        const value = getEnvVar(envKey);
        result[envKey] = checkVarEnvironment(value);
    });

    return result;
};

export const getEnv = (viteKey: string): string => {
    const runtimeKey = viteKey.startsWith('VITE_') ? viteKey.replace('VITE_', 'WEBVIEWS_') : viteKey;

    const placeholder = '${' + runtimeKey + '}';
    const winVal = (window as any)[runtimeKey];

    if (typeof winVal === 'string' && winVal !== '' && winVal !== placeholder) {
        return winVal;
    }

    const buildVal = (import.meta.env as any)[viteKey] as string | undefined;
    if (typeof buildVal === 'string' && buildVal !== '' && buildVal !== placeholder) {
        return buildVal;
    }

    return '';
};

export const setupEnvironmentProxy = () => {
    if (!import.meta.env.DEV) {
        const originalEnv = { ...(import.meta.env as any) };
        const proxiedEnv = new Proxy(originalEnv, {
            get(_target, prop) {
                const key = prop as string;
                return getEnv(key);
            },
        });
        Object.defineProperty(import.meta, 'env', { value: proxiedEnv, writable: false, configurable: false });
    }
};
